import { render, staticRenderFns } from "./RoutineBlocks.vue?vue&type=template&id=1806442e&scoped=true"
import script from "./RoutineBlocks.vue?vue&type=script&lang=js"
export * from "./RoutineBlocks.vue?vue&type=script&lang=js"
import style0 from "./RoutineBlocks.vue?vue&type=style&index=0&id=1806442e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806442e",
  null
  
)

export default component.exports